import React from 'react';
import { AlertTriangle, XCircle, WifiOff, Clock, Key } from 'lucide-react';
import { ERROR_TYPES } from '../utils/ErrorHandler';

/**
 * Enhanced error display component that shows different UI based on error type
 */
const ErrorDisplay = ({ error }) => {
    // If no error is provided, don't render anything
    if (!error) return null;

    // Default values
    let Icon = AlertTriangle;
    let title = 'Error';
    let alertClass = 'alert-error';
    let iconClass = 'text-error';

    // Customize based on error type
    switch (error.type) {
        case ERROR_TYPES.API_KEY:
            Icon = Key;
            title = 'API Key Error';
            break;
        case ERROR_TYPES.RATE_LIMIT:
            Icon = XCircle;
            title = 'Rate Limit Exceeded';
            alertClass = 'alert-warning';
            iconClass = 'text-warning';
            break;
        case ERROR_TYPES.NETWORK:
            Icon = WifiOff;
            title = 'Network Error';
            break;
        case ERROR_TYPES.TIMEOUT:
            Icon = Clock;
            title = 'Request Timeout';
            alertClass = 'alert-warning';
            iconClass = 'text-warning';
            break;
        default:
            // Default values already set
            break;
    }

    // Check if we're in debug mode to show error details
    const isDebugMode = process.env.REACT_APP_DEBUG_MODE === 'true';

    return (
        <div className={`alert ${alertClass} mb-6`}>
            <div className="flex">
                <div className={`flex-shrink-0 ${iconClass}`}>
                    <Icon className="h-5 w-5" />
                </div>
                <div className="ml-3">
                    <h3 className="text-sm font-medium">{title}</h3>
                    <div className="mt-2 text-sm">
                        <p>{error.message}</p>

                        {isDebugMode && error.details && (
                            <div className="mt-2 p-2 bg-white bg-opacity-50 rounded border border-gray-300 overflow-auto max-h-48">
                                <p className="font-mono text-xs">
                                    <strong>Debug Details:</strong> {error.details}
                                </p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ErrorDisplay;
